import React, { useState } from "react";
import { CreditCard, PaypalIcon } from "lucide-react";

const Payments = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handlePaymentTypeChange = (paymentType) => {
    if (selectedPaymentType === paymentType) {
      setSelectedPaymentType("");
    } else {
      setSelectedPaymentType(paymentType);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen md:p-4">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
          <div className="flex border-b border-gray-200">
            <div
              className={`px-5 py-4 text-center cursor-pointer ${activeTab === 0
                ? "border-b-2 border-blue-500 text-blue-600 font-medium"
                : "text-gray-600 hover:bg-gray-50"
                }`}
              onClick={() => handleTabClick(0)}
            >
              Payment Methods
            </div>
            <div
              className={`px-5 py-4 text-center cursor-pointer ${activeTab === 1
                ? "border-b-2 border-blue-500 text-blue-600 font-medium"
                : "text-gray-600 hover:bg-gray-50"
                }`}
              onClick={() => handleTabClick(1)}
            >
              Previous Payment
            </div>
          </div>
          <div className="w-full">
            {activeTab === 0 && (
              <div className="p-6">
                <div className="mb-4">
                  <h1 className="text-2xl font-bold text-gray-800">Payments</h1>
                </div>
                <div className="py-4">
                  <div className="mb-6 sm:w-full md:w-4/5 lg:w-1/2">
                    <select
                      id="household"
                      name="household"
                      value={selectedPaymentType}
                      onChange={(e) => handlePaymentTypeChange(e.target.value)}
                      className="w-full border border-gray-300 rounded-md p-2.5 text-base bg-transparent focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="">Make a new Payment</option>
                      <option value="1">One Time Payment</option>
                      <option value="2">Recurring Payment</option>
                      <option value="3">Set up Payment Method</option>
                      <option value="4">Existing payment method</option>
                      <option value="5">Add New Payment Method</option>
                      <option value="6">Add a Card</option>
                      <option value="7">Add a Bank Account</option>
                    </select>
                  </div>
                  <div className="mb-6 sm:w-full md:w-4/5 lg:w-1/2">
                    <label className="block mb-1 text-sm font-medium text-gray-700">Payment Reason</label>
                    <input
                      type="text"
                      className="w-full border border-gray-300 rounded-md p-2.5 text-base focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="mb-6 sm:w-full md:w-4/5 lg:w-1/2">
                    <div className="w-full">
                      <div
                        className={`my-3 p-3 border rounded-md flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200 ${selectedPaymentType === "card" ? "border-2 border-blue-500" : "border-gray-300"
                          }`}
                        onClick={() => handlePaymentTypeChange("card")}
                      >
                        <span>
                          <p className="font-medium text-gray-800">Card</p>
                          <p className="text-gray-600 text-sm">Pay with Mastercard, Visa or American Express</p>
                        </span>
                        <span>
                          <img
                            src={require("../../assets/card.png")}
                            width={"100px"}
                            alt="payment card"
                          />
                        </span>
                      </div>

                      <div
                        className={`my-3 p-3 border rounded-md flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200 ${selectedPaymentType === "paypal" ? "border-2 border-blue-500" : "border-gray-300"
                          }`}
                        onClick={() => handlePaymentTypeChange("paypal")}
                      >
                        <span>
                          <p className="font-medium text-gray-800">PayPal</p>
                          <p className="text-gray-600 text-sm">Safe and easy way to pay</p>
                        </span>
                        <span>
                          <img
                            src={require("../../assets/PayPal.png")}
                            width={"50px"}
                            alt="paypal logo"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="sm:w-full md:w-4/5 lg:w-1/2">
                    {selectedPaymentType === "card" && (
                      <div className="flex flex-wrap">
                        <div className="w-full mb-4">
                          <label className="block mb-1 text-sm font-medium text-gray-700">Card Number:</label>
                          <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2.5 text-base focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>

                        <div className="flex gap-5 w-full">
                          <div className="w-1/2 mb-4">
                            <label className="block mb-1 text-sm font-medium text-gray-700">Expiration Date</label>
                            <input
                              type="date"
                              className="w-full border border-gray-300 rounded-md p-2.5 text-base focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          </div>
                          <div className="w-1/2 mb-4">
                            <label className="block mb-1 text-sm font-medium text-gray-700">CVV</label>
                            <input
                              type="text"
                              className="w-full border border-gray-300 rounded-md p-2.5 text-base focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {selectedPaymentType === "paypal" && (
                      <div className="w-full">
                        <div className="mb-4">
                          <label className="block mb-1 text-sm font-medium text-gray-700">PayPal Email:</label>
                          <input
                            type="text"
                            className="w-full border border-gray-300 rounded-md p-2.5 text-base focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="sm:w-full md:w-4/5 lg:w-1/2 mt-6">
                    <button className="w-full cursor-pointer p-2.5 text-base border-none text-white bg-blue-500 hover:bg-blue-600 font-medium rounded-md transition-colors duration-200">Pay</button>
                  </div>
                </div>
              </div>
            )}
            {activeTab === 1 && (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-blue-400">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-medium text-white tracking-wider"></th>
                      <th className="px-4 py-3 text-right text-sm font-medium text-white tracking-wider">Previous Balance</th>
                      <th className="px-4 py-3 text-right text-sm font-medium text-white tracking-wider">Current Bal.</th>
                      <th className="px-4 py-3 text-right text-sm font-medium text-white tracking-wider">Total Balance</th>
                      <th className="px-4 py-3 text-right text-sm font-medium text-white tracking-wider">Last Payment Received</th>
                      <th className="px-4 py-3 text-right text-sm font-medium text-white tracking-wider">Last Payment AMT.</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    <tr className="bg-gray-50">
                      <td className="px-4 py-4 whitespace-nowrap">
                        <label className="checkbox-container flex justify-center">
                          <input type="checkbox" className="rounded text-blue-500 focus:ring-blue-500" />
                        </label>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$2,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$6,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$100.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <label className="checkbox-container flex justify-center">
                          <input type="checkbox" className="rounded text-blue-500 focus:ring-blue-500" />
                        </label>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$2,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$6,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$100.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="px-4 py-4 whitespace-nowrap">
                        <label className="checkbox-container flex justify-center">
                          <input type="checkbox" className="rounded text-blue-500 focus:ring-blue-500" />
                        </label>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$2,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$6,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$100.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <label className="checkbox-container flex justify-center">
                          <input type="checkbox" className="rounded text-blue-500 focus:ring-blue-500" />
                        </label>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$2,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$6,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$100.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="px-4 py-4 whitespace-nowrap">
                        <label className="checkbox-container flex justify-center">
                          <input type="checkbox" className="rounded text-blue-500 focus:ring-blue-500" />
                        </label>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$2,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$6,000.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$100.00</td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$0.00</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payments;